import type { ReactElement } from "react";
import { Link } from "react-router";
import { ClmIcon, type IconName } from "@/shared/components/icons/icon-map";
import {
  Badge,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui";

export interface ModuleComingSoonCardProps {
  moduleId: string;
  displayName: string;
  icon?: IconName;
}

export function ModuleComingSoonCard({
  moduleId,
  displayName,
  icon,
}: ModuleComingSoonCardProps): ReactElement {
  return (
    <Card className="shadow-sm" data-testid={`module-coming-soon-${moduleId}`}>
      <CardHeader>
        {icon ? (
          <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-clm-brand-blue/10 text-clm-primary-blue">
            <ClmIcon name={icon} decorative />
          </div>
        ) : null}
        <Badge variant="outline">Coming soon</Badge>
        {/* The card is the page's full content, so the module name is the page h1. */}
        <CardTitle as="h1" className="mt-2">
          {displayName}
        </CardTitle>
        <CardDescription>This module isn't ready to use yet.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm text-muted-foreground">
        <p>It will open from the dashboard when it becomes available.</p>
        <p>
          <Link
            to="/dashboard"
            className="font-medium text-clm-primary-blue underline-offset-2 hover:underline"
          >
            Go to dashboard
          </Link>
        </p>
      </CardContent>
    </Card>
  );
}
